// src/components/PurchaseOrdersList.jsx
import React, { useEffect, useState } from "react";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import ApprovePOButton from "./ApprovePOButton";

const StatusBadge = ({ status }) => {
  const base = "px-2 py-0.5 rounded text-xs font-medium";
  if (status === "approved") {
    return <span className={`${base} bg-green-100 text-green-800`}>Approved</span>;
  }
  if (status === "rejected") {
    return <span className={`${base} bg-red-100 text-red-800`}>Rejected</span>;
  }
  return <span className={`${base} bg-yellow-100 text-yellow-800`}>{status || "Draft"}</span>;
};

export default function PurchaseOrdersList() {
  const [pos, setPOs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const q = query(collection(db, "purchaseOrders"), orderBy("createdAt", "desc"));
      const snap = await getDocs(q);
      setPOs(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error("load PO error", err);
      setError("Failed to load purchase orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-3">Purchase Orders</h2>

      {error && <div className="mb-2 p-2 bg-red-100 text-red-800 rounded">{error}</div>}

      <div className="overflow-auto border rounded">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 text-left">PO No</th>
              <th className="p-2 text-left">Supplier</th>
              <th className="p-2 text-right">Items</th>
              <th className="p-2 text-center">Status</th>
              <th className="p-2 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="p-4 text-center text-gray-500">
                  Loading purchase orders...
                </td>
              </tr>
            ) : pos.length === 0 ? (
              <tr>
                <td colSpan={5} className="p-4 text-center text-gray-500">
                  No purchase orders found
                </td>
              </tr>
            ) : (
              pos.map((po) => (
                <tr key={po.id} className="border-t">
                  <td className="p-2">{po.poNo || "— draft —"}</td>
                  <td className="p-2">{po.supplierName || po.supplierId || "N/A"}</td>
                  <td className="p-2 text-right">{(po.items || []).length}</td>
                  <td className="p-2 text-center">
                    <StatusBadge status={po.status} />
                  </td>
                  <td className="p-2 text-center">
                    {po.status === "draft" && (
                      <ApprovePOButton poId={po.id} onApproved={load} />
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
